import React from 'react';
import { call, takeEvery } from 'redux-saga/effects';
import {
  SystemTaskAdapterForm,
  mountForm,
  unmountForm,
} from '@kineticdata/react';
import { generateFormButtons, FormError } from '@kineticdata/ui';
import { regRoute, regSaga } from '../../store';
import {
  DATABASE_ADAPTER_FIELDS,
  MssqlPropertyLayout,
  OraclePropertyLayout,
  PostgresPropertyLayout,
} from '../common/DatabaseAdapters';

const formKey = 'system-setup-task';

regRoute('SYSTEM_TASK_PAGE', '/system/setup/infra/task');

regSaga(
  takeEvery('ENTER_SYSTEM_TASK_PAGE', function*() {
    yield call(mountForm, formKey);
  }),
);
regSaga(
  takeEvery('LEAVE_SYSTEM_TASK_PAGE', function*() {
    yield call(unmountForm, formKey);
  }),
);

const handleSave = () => () => {
  unmountForm(formKey);
  mountForm(formKey);
};

const FormLayout = ({ fields, error, buttons, bindings }) => {
  const currentAdapter = bindings.values.get('type');

  return (
    <form>
      <div className="heading heading-sm">
        <h2 className="h3">Task Setup</h2>
      </div>
      {fields.get('type')}
      {currentAdapter === 'mssql' ? (
        <MssqlPropertyLayout fields={fields} values={bindings.values} />
      ) : currentAdapter === 'oracle' ? (
        <OraclePropertyLayout fields={fields} values={bindings.values} />
      ) : currentAdapter === 'postgres' ? (
        <PostgresPropertyLayout fields={fields} values={bindings.values} />
      ) : null}
      {error}
      <div className="form-buttons">{buttons}</div>
    </form>
  );
};

export const SystemSetupTask = () => (
  <div className="content-container">
    <SystemTaskAdapterForm
      formKey={formKey}
      onSave={handleSave}
      components={{
        FormError,
        FormButtons: generateFormButtons({
          submitLabel: 'Update Default Task DB Adapter',
          cancelPath: '/system/setup/config',
        }),
        FormLayout,
      }}
      alterFields={{
        ...DATABASE_ADAPTER_FIELDS(),
      }}
    >
      {({ form }) => form}
    </SystemTaskAdapterForm>
  </div>
);
